import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { NEGATIVE_COLOR, THIRD_COLOR } from '../../config/colors'
import { AddressWrapperDiv, HeaderDiv, HeaderTitleDiv, HeaderIconImg } from '../../pages';
import * as addressReducer from '../../reducers/addressReducer';
import AddressBar from '../../components/AddressBar';

import { ordersUri, rootPageUri } from '../../config/uri';
import * as historyReducer from '../../reducers/historyReducer';
import styled from 'styled-components';
import { formatDate } from '../../helpers/date.js';
import { NextIcon } from '../../icons';
import { startGetMoreOrders, startGetOrders } from '../../actions/order';
import RaisedButton from 'material-ui/RaisedButton';
import { getEcommerceUser } from '../../selectors/userSelectors';
import { isUser } from '../../reducers/userReducer';
import { isPaymentKiosk } from '../../selectors/configSelectors';
import { getPaymentKioskLoginMode } from '../../services/paymentKiosk';
import { LOGIN_MODE } from '../../const/paymentKiosk';

import './style.css'
import { pushWithQueryParams } from '../../services/uri';

const pastOrdersDark = process.env.PUBLIC_URL + '/assets/img/icons/menu/order_dark.svg';

const styles = {
  headerIcon: { width: '30px', height: '30px' },
  nextIcon: { width: '30px', height: '40px' },
  labelStyle: { fontWeight: 700 }
}

const status = {
  VERIFICATION_PENDING: 'Verification Pending',
  AWAITING_PROCESSING: 'Awaiting Processing',
  IN_PROCESS: 'In Process',
  PACKED_READY: 'Packed & Ready',
  OUT_FOR_DELIVERY: 'Out For Delivery',
  COMPLETED: 'Complete',
  CANCELED: 'Canceled',
  REMOVED: 'Removed',
}

class OrdersPage extends Component {
  state = {
    loading: false,
    orders: this.props.customerOrders || [],
    noOrders: true
  };

  componentDidMount() {
    if (this.props.isUser) {
      this.props.fetchOrderHistory();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.customerOrders.length === 0 && nextProps.customerOrders.length > 0) {
      this.setState({
        orders: nextProps.customerOrders,
        loading: false,
        noOrders: false
      })
    }
  }

  handleOrderClick = (orderId) => {
    this.props.orderHistory(orderId);
  }

  getOrders = () => {
    const { customerOrders } = this.props;

    return customerOrders
      .sort((a, b) => {
        const dateA = Date.parse(a.lastUpdateAt);
        const dateB = Date.parse(b.lastUpdateAt);

        return dateA > dateB ? -1 : dateA < dateB ? 1 : 0;
      })
      .map((o, i) => {
        let markOrder = '';

        if (o.changed) {
          markOrder = <div className="updated" />;
        }

        return <Order key={i} onClick={this.handleOrderClick.bind(null, o.orderId)}>
          <Receipt>
            <OrderNumber>Receipt #{o.orderNumber}</OrderNumber>
            <OrderDate>{formatDate(new Date(o.dateCreated))}</OrderDate>
          </Receipt>
          <StatusWrap>
            <Status>{markOrder}{status[o.status]}</Status>
          </StatusWrap>
          <Icon>
            <NextIcon color={NEGATIVE_COLOR} style={styles.nextIcon} />
          </Icon>
        </Order>
      });
  }

  handleBackToShopClick = () => {
    this.props.backToShop();
  }

  loadMoreOrders = () => {
    const { currentPage } = this.props.ordersState;
    this.props.fetchMoreOrders(currentPage + 1);
  }

  renderShowMore = () => {
    const { ordersState } = this.props;

    const { currentPage, totalPages } = ordersState;

    const isMore = currentPage + 1 < totalPages;

    if (!isMore) {
      return null;
    }

    return (
      <div style={{ padding: '20px 0', textAlign: 'center' }}>
        <RaisedButton
          onClick={(e) => this.loadMoreOrders(e)}
          label="Show more orders"
          backgroundColor={`#` + this.props.secondaryColor}
          labelColor="#FFF"
          labelStyle={styles.labelStyle}
        />
      </div>
    );
  }

  render() {
    const { isAddressBarOpened, isPaymentKiosk, customerOrders } = this.props;

    if (isPaymentKiosk) {
      const paymentKioskloginMode = getPaymentKioskLoginMode();

      if (paymentKioskloginMode === LOGIN_MODE.WITH_REDIRECT) {
        if (Array.isArray(customerOrders) && customerOrders.length === 1) {
          const orderId = customerOrders[0].orderId;
          const orderUri = ordersUri + '/' + orderId;

          return <Redirect to={orderUri} />;
        }
      }
    }

    const ordersList = this.getOrders();

    return (
      <div>
        <HeaderDiv>
          <HeaderIconImg style={styles.headerIcon} src={pastOrdersDark} />
          <HeaderTitleDiv>ORDERS</HeaderTitleDiv>
        </HeaderDiv>
        <div className="order-container">
          {ordersList}
          {this.renderShowMore()}
          {ordersList.length === 0 &&
            <div>
              <NoItemsDiv>No Orders Yet</NoItemsDiv>
              <div style={{ paddingTop: '40px', textAlign: 'center' }}>
                <RaisedButton
                  onClick={(e) => this.handleBackToShopClick(e)}
                  label="Back To Shop"
                  backgroundColor={`#` + this.props.secondaryColor}
                  labelColor="#FFF"
                  labelStyle={styles.labelStyle}
                />
              </div>
            </div>
          }
          {this.state.loading && <NoItemsDiv>Loading...</NoItemsDiv>}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    orders: historyReducer.getOrders(state),
    isAddressBarOpened: addressReducer.isAddressBarOpened(state),
    secondaryColor: state.config.secondaryColor,
    customerOrders: state.orders.orders,
    user: getEcommerceUser(state),
    ordersState: state.orders,
    isPaymentKiosk: isPaymentKiosk(state),
    isUser: isUser(state)
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    orderHistory: (orderId) => dispatch(pushWithQueryParams(ordersUri + '/' + orderId)),
    backToShop: () => dispatch(pushWithQueryParams(rootPageUri)),
    fetchMoreOrders: (page) => dispatch(startGetMoreOrders(page)),
    fetchOrderHistory: () => dispatch(startGetOrders()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrdersPage);

const Order = styled.div`
  cursor: pointer;
  position: relative;
  box-sizing: border-box;
  position: relative;
  display: flex;
  padding-left: 36px;
  align-items: center;
  border-bottom: 2px solid ${THIRD_COLOR};
  width: 100%;
`;

const Receipt = styled.div`
    padding: 28px 0;
    width: 100%;
`;

const StatusWrap = styled.div`
  position: absolute;
  right: 0;
  top: 50px;
`;

const Status = styled.div`
  position: absolute;
  right: 60px;
  font-size: 13px;
  white-space: nowrap;
`;

const OrderNumber = styled.div`
  font-size: 16px;
  font-weight: 700;
`;

const OrderDate = styled.div`
`;

const Icon = styled.div`
  position: absolute;
  right: 0;
  top: 25px;
`;

const NoItemsDiv = styled.div` 
  padding-top: 20px;
  text-align: center;
`;



// WEBPACK FOOTER //
// ./src/components/OrdersPage/OrdersPage.jsx